<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="900"
      :mask-closable="false"
      title="导入客户CPE"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form class="simiot-nested-search-form" :form="searchForm" @submit="handleSearch">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="CPE型号">
              <a-select
                v-decorator="['cpe_model_id']"
                allow-clear
                show-search
                option-filter-prop="children"
                placeholder="请选择"
                :loading="loadingCpeModelOptions"
              >
                <a-select-option
                  v-for="opt in cpeModelOptions"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ formatModelOption(opt) }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="通讯方式">
              <a-select
                v-decorator="['comm_mode_id']"
                allow-clear
                show-search
                option-filter-prop="children"
                placeholder="请选择"
                :loading="loadingCommModeOptions"
              >
                <a-select-option
                  v-for="opt in commModeOptions"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-space>
                <a-button type="primary" html-type="submit">搜索</a-button>
                <a-button @click="handleReset">刷新</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        size="middle"
        :columns="tableColumns"
        :data-source="tableData"
        :loading="loading"
        :pagination="false"
        :scroll="{ y: 350 }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        row-key="id"
      />

      <a-row class="count-tips">
        共 {{ tableData.length }} 条记录，已选中 {{ selectedRowKeys.length }} 条数据
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findCpeSupplierModelOptions } from '@/api/cpe_supplier_model'
import { findImportableBaseCpeProducts } from '@/api/base_cpe_product'
import { importAgentsCpeProducts } from '@/api/agents_cpe_product'
import { formatFloat } from '@/utils/filter'

export default {
  name: 'ImportAgentsCpeProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    agentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      searchForm: this.$form.createForm(this, { name: 'import_agents_cpe_product_search' }),
      loading: true,
      selectedRowKeys: [],
      query: {},
      submitting: false,
      cpeModelOptions: [],
      commModeOptions: [],
      loadingCpeModelOptions: false,
      loadingCommModeOptions: false,
      tableColumns: [
        { title: '采购型号', dataIndex: 'cpe_model_name' },
        { title: '对外展示型号', dataIndex: 'display_model' },
        { title: '通讯方式', dataIndex: 'comm_mode_name' },
        { title: '单价(元/台)', dataIndex: 'unit_price', customRender: formatFloat },
        { title: '底价(元/台)', dataIndex: 'floor_price', customRender: formatFloat }
      ],
      tableData: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    findCpeSupplierModelOptions({}).then((res) => {
      if (res.code === 0) {
        this.cpeModelOptions = res.data
      }
    })
    findCommonTypeOptions('product_comm_mode').then((res) => {
      if (res.code === 0) {
        this.commModeOptions = res.data
      }
    })
    this.fetchData()
  },
  methods: {
    formatModelOption(opt) {
      if (opt.display_model && opt.display_model !== opt.purchase_model) {
        return `${opt.purchase_model}（对外：${opt.display_model}）`
      }
      return opt.purchase_model || opt.name
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findImportableBaseCpeProducts(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        this.tableData = res.data || []
        this.loading = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      this.searchForm.validateFields((err, values) => {
        if (!err) {
          this.query = values
          this.fetchData()
        }
      })
    },

    handleReset() {
      this.searchForm.resetFields()
      this.query = {}
      this.fetchData()
    },

    handleSubmit() {
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }
      if (this.selectedRowKeys.length === 0) {
        this.$warning({ title: '请选择操作对象', content: '' })
        return
      }

      this.submitting = true
      importAgentsCpeProducts({
        agent_id: this.agentId,
        base_cpe_product_ids: this.selectedRowKeys
      }).then((res) => {
        if (res.code === 0) {
          this.isShow = false
          this.$emit('completed')
        }
        this.submitting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.count-tips {
  padding-top: 20px;
}
</style>
